import type { PortalAudience } from '@/access/portalAccess.types';
import { WORKER_FILTER_KEYS } from '@/modules/workers/utils/workerFilters.utils';
import type { WorkersViewInput } from '@/modules/workers/workers.viewInput';

export type WorkerFilterKey = (typeof WORKER_FILTER_KEYS)[number];

export type WorkersListQueryType = 'tenant';

export type WorkersListView = {
  audience: PortalAudience;
  filterKeys: WorkerFilterKey[];
  actions: {
    showSearch: boolean;
  };
  query: {
    workers: {
      strategy: WorkersListQueryType;
    };
    classifications: {
      fetch: boolean;
    };
    tenantUsers: {
      fetch: boolean;
    };
  };
};

export const getWorkersListView = ({
  access,
}: WorkersViewInput): WorkersListView => {
  const { audience } = access;

  return {
    audience,
    filterKeys: [...WORKER_FILTER_KEYS],
    actions: {
      showSearch: true,
    },
    query: {
      workers: {
        strategy: 'tenant',
      },
      classifications: {
        fetch: true,
      },
      tenantUsers: {
        fetch: true,
      },
    },
  };
};
